import mixpanel from 'mixpanel-browser';

// Enabling the debug mode flag is useful during implementation,
// but it's recommended you remove it for production
export const MixPanelEvents = {

    Billzy_Login: 'Billzy_Login',
    Billzy_Login_Resend_OTP: 'Billzy_Login_Resend_OTP',
    Billzy_Login_Proceed: 'Billzy_Login_Proceed',
    Billzy_Login_OTP_Proceed: 'Billzy_Login_OTP_Proceed',
    Billzy_sidebar_Login_Create_an_account: 'Billzy_sidebar_Login_Create_an_account',
    'Billzy_Login_Create_an_account _Login':
        'Billzy_Login_Create_an_account _Login',
    'Billzy_Login_Create_an_account _Proceed':
        'Billzy_Login_Create_an_account _Proceed',
    'Billzy _sidebar _Login': 'Billzy _sidebar _Login',
    Billzy_Home_Terms_and_condition: 'Billzy_Home_Terms_and_condition',
    Billzy_Home_Terms_and_condition_Privacy_Policy:
        'Billzy_Home_Terms_and_condition_Privacy_Policy',
    Billzy_Home_About_us: 'Billzy_Home_About_us',
    Billzy_Home_FAQs: 'Billzy_Home_FAQs',
    'Billzy_Home_FAQs_ How to get my bill details?_CTA':
        'Billzy_Home_FAQs_ How to get my bill details?_CTA',
    'Billzy_Home_FAQs_ Why do I require to log in?':
        'Billzy_Home_FAQs_ Why do I require to log in?',
    'Billzy_Home_FAQs_ Why do I require to log in?_Login Now-':
        'Billzy_Home_FAQs_ Why do I require to log in?_Login Now-',
    'Billzy_Home_FAQs_ My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?':
        'Billzy_Home_FAQs_ My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?',
    'Billzy_Home_FAQs_ My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?_Transaction':
        'Billzy_Home_FAQs_ My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?_Transaction',
    'Billzy_Home_FAQs_ I used these details to fetch my bill earlier but now I am unable to find my bill.':
        'Billzy_Home_FAQs_ I used these details to fetch my bill earlier but now I am unable to find my bill.',
    'Billzy_Home_FAQs_How to update my contact details like Phone number, Email address, etc?':
        'Billzy_Home_FAQs_How to update my contact details like Phone number, Email address, etc?',
    'Billzy_Home_FAQs_How to update my contact details like Phone number, Email address, etc?_Profile Setting':
        'Billzy_Home_FAQs_How to update my contact details like Phone number, Email address, etc?_Profile Setting',
    'Billzy_Home_FAQs_How to update my contact details like Phone number, Email address, etc?_Profile Setting':
        'Billzy_Home_FAQs_How to update my contact details like Phone number, Email address, etc?_Profile Setting',
    'Billzy_Home_FAQs_Feedback_You did great!_CTA':
        'Billzy_Home_FAQs_Feedback_You did great!_CTA',
    "Billzy_Home_FAQs_Feedback_I'm not satisfied_CTA":
        "Billzy_Home_FAQs_Feedback_I'm not satisfied_CTA",
    Billzy_Home_FAQs_Feedback_Submit_CTA:
        'Billzy_Home_FAQs_Feedback_Submit_CTA',
    'Billzy _User_Home': 'Billzy _User_Home',
    BIllzy_User_Order_and_Transaction_CTA:
        'BIllzy_User_Order_and_Transaction_CTA',
    Billzy_User_Mandate: 'Billzy_User_Mandate',
    'Billzy _User_ Dispute_and_Chargeback':
        'Billzy _User_ Dispute_and_Chargeback',
    'Billzy _User_ Orders and transaction _Check_and_Retry':
        'Billzy _User_ Orders and transaction _Check_and_Retry',
    Transaction_Details_Dropdown: 'Transaction_Details_Dropdown',
    Transaction_Details_copy_order_id: 'Transaction_Details_copy_order_id',
    Transaction_Details_download_receipt:
        'Transaction_Details_download_receipt',
    Billzy_User_Profile_Settings: 'Billzy_User_Profile_Settings',
    Profile_Settings_Full_name_Update: 'Profile_Settings_Full_name_Update',
    Profile_Settings_Full_name_Save: 'Profile_Settings_Full_name_Save',
    Profile_Settings_mobile_number_Update:
        'Profile_Settings_mobile_number_Update',
    Profile_Settings_mobile_number_Resend_otp:
        'Profile_Settings_mobile_number_Resend_otp',
    Profile_Settings_mobile_number_proceed:
        'Profile_Settings_mobile_number_proceed',
    Enter_new_Mobile_number_proceed: 'Enter_new_Mobile_number_proceed',
    Udpated_new_Mobile_number_Proceed: 'Udpated_new_Mobile_number_Proceed',
    Profile_Settings_email_address_add: 'Profile_Settings_email_address_add',
    Profile_Settings_email_address_add_proceed:
        'Profile_Settings_email_address_add_proceed',
    Profile_Settings_email_address_update:
        'Profile_Settings_email_address_update',
    Profile_Settings_email_address_Proceed:
        'Profile_Settings_email_address_Proceed',
    'Biilzy _ User_Profile_Settings_Logout':
        'Biilzy _ User_Profile_Settings_Logout',
    Billzy_show_Loans: 'Billzy_show_Loans',
    'Billzy_show_Loans _Check_and_Pay': 'Billzy_show_Loans _Check_and_Pay',
    Billzy_Recent_Transaction_View_all_: 'Billzy_Recent_Transaction_View_all_',
    Billzy_Payment_Screen_Edit_CTA: 'Billzy_Payment_Screen_Edit_CTA',
    Billzy_Payment_Screen_Edit_View_Breakup:
        'Billzy_Payment_Screen_Edit_View_Breakup',
    'Payment_Screen_Minimum_Amount _CTA': 'Payment_Screen_Minimum_Amount _CTA',
    'Payment_Screen_Maximum_Amount _CTA': 'Payment_Screen_Maximum_Amount _CTA',
    Billzy_Payment_Screen_Proceed_to_pay:
        'Billzy_Payment_Screen_Proceed_to_pay',
    'Billzy _Payment _Screen_Debit_Card': 'Billzy _Payment _Screen_Debit_Card',
    'Billzy _Payment _Screen_Net_Banking':
        'Billzy _Payment _Screen_Net_Banking',
    'Billzy _Payment _Screen_UPI': 'Billzy _Payment _Screen_UPI',
    'Billzy _UPI_Scan_QR_code': 'Billzy _UPI_Scan_QR_code',
    'Billzy _UPI_VPA_address_Verify': 'Billzy _UPI_VPA_address_Verify',
    Billzy_Payment_Method_Proceed_to_pay:
        'Billzy_Payment_Method_Proceed_to_pay',
    Billzy_successful_transaction_rating:
        'Billzy_successful_transaction_rating',
    Billzy_successful_transaction_rating_skip_now:
        'Billzy_successful_transaction_rating_skip_now',
    Billzy_successful_transaction_Download_Receipt:
        'Billzy_successful_transaction_Download_Receipt',
    Billzy_successful_transaction_Make_New_Payment_CTA:
        'Billzy_successful_transaction_Make_New_Payment_CTA',
    'Side_nav_create an account': 'Side_nav_create an account',
    Billzy_Payment_Success: 'Billzy_Payment_Success',
};

export const MixPanelCTA = {
    click: 'On Click',
    onLoad: 'On Load',
};

export const EventProperites = {

    'User Login': 'User Login',
    'Billzy -Create an Account': 'Billzy -Create an Account',
    'Terms and condition': 'Terms and condition',
    'Billzy-Home-Terms-and-condition-Privacy-Policy':
        'Billzy-Home-Terms-and-condition-Privacy-Policy',
    'Home Page - About us': 'Home Page - About us',
    'Home page - FAQs': 'Home page - FAQs',
    'FAQs- How to get my bill details?': 'FAQs- How to get my bill details?',
    'FAQs -  Why do I require to log in?':
        'FAQs -  Why do I require to log in?',
    'FAQs-  Why do I require to log in- Login Now':
        'FAQs-  Why do I require to log in- Login Now',
    'FAQs-My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?':
        'FAQs-My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?',
    'FAQs-My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?-Transaction':
        'FAQs-My payment is showing as failed on Billzy but the amount has been deducted from my account. What should I do?-Transaction',
    'FAQs-I used these details to fetch my bill earlier but now I am unable to find my bill.':
        'FAQs-I used these details to fetch my bill earlier but now I am unable to find my bill.',
    'FAQs-How to update my contact details like Phone number, Email address, etc?':
        'FAQs-How to update my contact details like Phone number, Email address, etc?',
    'FAQs-How to update my contact details like Phone number, Email address, etc?-Profile Setting':
        'FAQs-How to update my contact details like Phone number, Email address, etc?-Profile Setting',
    'FAQs-Feedback-You did great! -CTA': 'FAQs-Feedback-You did great! -CTA',
    "Billzy-Home-FAQs-Feedback-I'm not satisfied-CTA":
        "Billzy-Home-FAQs-Feedback-I'm not satisfied-CTA",
    'FAQs-Feedback-Submit-CTA': 'FAQs-Feedback-Submit-CTA',
    'Billzy -User - Home': 'Billzy -User - Home',
    Home_User_Order_and_Transaction_CTA:
        'BIllzy_User_Order_and_Transaction_CTA',
    'Billzy - User - Mandate': 'Billzy - User - Mandate',
    'Billzy - User - Dispute and Chargeback':
        'Billzy - User - Dispute and Chargeback',
    'Billzy -User-Order and Transaction-Check-and-Retry':
        'Billzy -User-Order and Transaction-Check-and-Retry',
    'Transaction--Details-Dropdown': 'Transaction--Details-Dropdown',
    'Transaction-Details-order-id': 'Transaction-Details-order-id',
    'Transaction-Details-downlaod receipt':
        'Transaction-Details-downlaod receipt',
    'Billzy - User - Profile Settings': 'Billzy - User - Profile Settings',
    'Profile Settings_Full_name_Update': 'Profile Settings_Full_name_Update',
    'Profile Settings_Full_name_Save': 'Profile Settings_Full_name_Save',
    'Profile-Settings-mobile-number-Update':
        'Profile-Settings-mobile-number-Update',
    'Profile-Settings-mobile-number-resend-otp':
        'Profile-Settings-mobile-number-resend-otp',
    'Profile-Settings-mobile-number-proceed':
        'Profile-Settings-mobile-number-proceed',
    'Enter-new-mobile-number-proceed': 'Enter-new-mobile-number-proceed',
    'Udpated-new-Mobile-number-Proceed': 'Udpated-new-Mobile-number-Proceed',
    'Profile-Settings-email-address-add': 'Profile-Settings-email-address-add',
    'Profile-Settings-email-address-add_proceed':
        'Profile-Settings-email-address-add_proceed',
    'Profile-Settings-email-address-update':
        'Profile-Settings-email-address-update',
    'Profile-Settings-email-address-Proceed':
        'Profile-Settings-email-address-Proceed',
    'Profile -Setting - Logout': 'Profile -Setting - Logout',
    'Billzy - Show Loans': 'Billzy - Show Loans',
    'Billzy-Check and Pay': 'Billzy-Check and Pay',
    'Billzy-View-all-dropdown': 'Billzy-View-all-dropdown',
    'Billzy-Payment-Screen-Edit-CTA': 'Billzy-Payment-Screen-Edit-CTA',
    'Billzy-Payment-Screen-Edit-View-Breakup':
        'Billzy-Payment-Screen-Edit-View-Breakup',
    Payment_Screeen_Minimum_Amount: 'Payment_Screeen_Minimum_Amount',
    Payment_Screeen_Maximum_Amount: 'Payment_Screeen_Maximum_Amount',
    'Billzy - Payment Screen - Proceed to pay':
        'Billzy - Payment Screen - Proceed to pay',
    'Billzy Payment -Screen - Debit card':
        'Billzy Payment -Screen - Debit card',
    'Billzy Payment -Screen - Net banking':
        'Billzy Payment -Screen - Net banking',
    'Billzy Payment -Screen - UPI': 'Billzy Payment -Screen - UPI',
    'Billzy-UPI-Scan-QR-code': 'Billzy-UPI-Scan-QR-code',
    'Billzy-UPI-VPA-address-verify': 'Billzy-UPI-VPA-address-verify',
    'Billzy - Payment Method - Proceed to pay':
        'Billzy - Payment Method - Proceed to pay',
    'Billzy -successful - transaction - expreince rating':
        'Billzy -successful - transaction - expreince rating',
    'Billzy -successful - transaction - expreince rating - skip now':
        'Billzy -successful - transaction - expreince rating - skip now',
    'Billzy - successful -transaction - download -receipt':
        'Billzy - successful -transaction - download -receipt',
    'Billzy - successful -transaction - Make-New-payment':
        'Billzy - successful -transaction - Make-New-payment',
    'Side-nav-create an account': 'Side-nav-create an account',
    'Billzy - successful -transaction - payment - success': 'Billzy - successful -transaction - payment - success',
};

export const MixPanelCategory = {
    Authentication: 'Authentication',
    Exprience: 'Exprience',
    'Payment mode': 'Payment mode',
};

export const handleLoginEvent = (property) => {
    mixpanel.reset();
    mixpanel.identify(property);
    mixpanel.register({ 'Mobile Number': property });
};

export const handlEvents = ({
    events = '',
    module = '',
    category = '',
    element = undefined,
    cta = '',
    para1 = {},
    para2 = {},
    mobileNumber = '',
    dataSource = undefined,
}) => {
    if (process.env.NODE_ENV === 'production') {
        mixpanel.init(process.env.NEXT_PUBLIC_MIX_PANEL_ID, {
            record_sessions_percent: 1,
            record_idle_timeout_ms: 1800000,
        });
        if (mobileNumber) handleLoginEvent(mobileNumber);
        else if (
            events === MixPanelEvents["Biilzy _ User_Profile_Settings_Logout"]
        )
            mixpanel.reset();
        const property = {
            Module: module,
            Elements: element,
            Category: category,
            Cta: cta,
            'Parameters 1': para1,
            'Parameters 2': para2,
            DataSource: dataSource,
        };
        mixpanel.track(events, property);
    }
};

export const sessionReplayMixpanel = () => {
    if (process.env.NODE_ENV === 'production') {
        const mixpanelToken = process.env.NEXT_PUBLIC_MIX_PANEL_ID;
        if (mixpanelToken) {
            mixpanel.init(mixpanelToken, {
                record_sessions_percent: 100,
                autocapture: true,
            });

        }
        
    }
};

